import deepMerge from 'lodash.merge';
import {ClickScrollPlugin, OverlayScrollbars} from 'overlayscrollbars';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './scroll.component.module.styl';

import type {PartialOptions} from 'overlayscrollbars';


// Note: If scrollbars.clickScroll set to true the ClickScrollPlugin is required.
OverlayScrollbars.plugin(ClickScrollPlugin);

const classNames = withCssModule(styles);

export type Options = {
    darkMode?: boolean,
} & PartialOptions;

export const getDefaultOptions = (options?: Options): Options => deepMerge({
    scrollbars: {
        autoHide: 'move',
        clickScroll: true,
        theme: classNames('os-theme', {
            'os-theme-light': options?.darkMode,
            'os-theme-dark': !options?.darkMode,
        }),
    },
}, options);
